// src/components/Footer.jsx
import "../index.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-left">
        <p>© LuckyHouseLLC. All rights reserved.</p>
      </div>
      <div className="footer-right">
      </div>
    </footer>
  );
}
